/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ModalConfirm } from "@nordcloud/gnui";
import { showSuccess } from "~/services/toast";
import { useDeleteMappingRule } from "~/views/mappingRules/hooks/useDeleteMappingRule/useDeleteMappingRule";

type Props = {
  isDeleteModalOpen: boolean;
  close: () => void;
  onSuccess?: () => void;
  id: string;
  tagName: string;
};

export function DeleteMappingRule({
  isDeleteModalOpen,
  close,
  onSuccess,
  id,
  tagName,
}: Props) {
  const [deleteMappingRule] = useDeleteMappingRule({
    onSuccess: () => {
      showSuccess("Mapping Rule deleted successfully!");
      close();
      onSuccess?.();
    },
  });

  async function onDelete() {
    await deleteMappingRule(id);
  }

  return (
    <ModalConfirm
      onClose={close}
      isOpen={isDeleteModalOpen}
      confirm={() => onDelete()}
      actionLabel="Delete"
      contentLabel={`Delete Plan`}
      data-testid="modal-delete-mapping-rule"
    >
      {`Are you sure you want to delete ${tagName}?`}
    </ModalConfirm>
  );
}
